import React from 'react'
import View from './view'

const EventHome = ({ ...props }) => {
    return <View {...props} />
}

export default EventHome
